// extracted by mini-css-extract-plugin
export default {"root":"style_root__kVhmh","logo":"style_logo__bUVde","btn":"style_btn__dMd5B","logout":"style_logout__UDyq4"};